import React from 'react'
import { Modal } from 'react-bootstrap'
export default function WorkingSevenMedals(
 {
  pageLanguage ,
  modals ,
  modalHandleClose ,
  t ,
 }
) {
  return (
   <Modal
   keyboard={false}
   dialogClassName={`Zipcode_how_it_works customSizeModal ${
     pageLanguage === "fa" ? "font_farsi" : "font_en"
   }`}
   show={modals["Zipcode_how_it_works"] === undefined ? false : modals["Zipcode_how_it_works"]}
   onHide={() => {
     modalHandleClose("Zipcode_how_it_works");
   }}
 >
   <Modal.Header closeButton></Modal.Header>
   <Modal.Body>
     <div className="zipcode_modal_title_container">
       <h1 className="zipcode_modal_title">{t("zipcode_modal_text1")}</h1>
     </div>
     <div className="zipcode_modal_body">
       <div className="zipcode_modal_item">
         <div className="zipcode_modal_item_img_container">
           <img
             src={require("../../Images/public/zipcode_bag.png")}
             className="img-fluid"
             alt=""
           />
         </div>
         <div className="zipcode_modal_item_title_container">{t("zipcode_modal_text2")}</div>
         <div className={`zipcode_modal_item_text_container ${pageLanguage === "fa" ? "font_farsi" : ""}`}>
          {t("zipcode_modal_text3")}</div>
       </div>
       <div className="zipcode_modal_item">
         <div className="zipcode_modal_item_img_container">
           <img
             src={require("../../Images/public/zipcode_mark.png")}
             className="img-fluid"
             alt=""
           />
         </div>
         <div className="zipcode_modal_item_title_container">{t("zipcode_modal_text4")}</div>
         <div className="zipcode_modal_item_text_container">{t("zipcode_modal_text5")}</div>
       </div>
       <div className="zipcode_modal_item">
         <div className="zipcode_modal_item_img_container">
           <img
             src={require("../../Images/public/zipcode_truck.png")}
             className="img-fluid"
             alt=""
           />
         </div>
         <div className="zipcode_modal_item_title_container">{t("zipcode_modal_text6")}</div>
         <div className="zipcode_modal_item_text_container">{t("zipcode_modal_text7")}</div>
       </div>
       <div className="zipcode_modal_item">
         <div className="zipcode_modal_item_img_container">
           <img
             src={require("../../Images/public/zipcode_tools.png")}
             className="img-fluid"
             alt=""
           />
         </div>
         <div className="zipcode_modal_item_title_container">{t("zipcode_modal_text8")}</div>
         <div className="zipcode_modal_item_text_container">{t("zipcode_modal_text9")}</div>
       </div>
     </div>
     <div className="zipcode_modal_footer">
       <div className="zipcode_modal_item_text_container">{t("zipcode_modal_text10")}</div>
     </div>
   </Modal.Body>
 </Modal>
  )
}
